module.exports = __webpack_public_path__ + "img/modern-cosmetics-1.cf5afa9e.jpg";